// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { promotionCodeFormStyles } from "@insite/content-library/Widgets/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitPromotionCode";
import { css } from "styled-components";

promotionCodeFormStyles.gridContainer = {
    gap: 0,
};

promotionCodeFormStyles.promotionCodeGridItem = {
    width: 8,
    css: css`
        &&& {
            max-width: none;
            flex-grow: 1;
        }
    `,
};

promotionCodeFormStyles.applyPromotionGridItem = {
    width: 4,
    css: css`
        display: flex;
        &&& {
            flex-basis: auto;
        }
    `,
};